import { fiflboxApi } from '@/utils/api';
import { makeGetters, makeSetters } from '@/utils/vuex-helper';
import { format } from 'date-fns';

const defaultPageDecider = state => {
  if (state.handle_dashboard) {
    return '/dashboard';
  } else if (state.handle_schedule) {
    return '/course/schedule';
  } else if (state.handle_timetable) {
    return '/course/timetable';
  } else if (state.handle_analytics) {
    return '/analytics';
  } else if (state.handle_locker) {
    return '/locker';
  } else if (state.handle_registered_member) {
    return '/member/valid';
  } else if (state.handle_pending_member) {
    return '/member/waiting';
  } else if (state.handle_create_member) {
    return '/member/register';
  } else if (state.handle_notice) {
    return '/notices';
  } else if (state.handle_wod) {
    return `/wods?date=${format(new Date(), 'YYYY-MM-DD')}`;
  } else if (state.handle_setting) {
    return '/setting/policy';
  }
};

const state = {
  instructorRoles: [],
  instructorAccessAuth: {
    handle_dashboard: true,
    handle_schedule: true,
    handle_timetable: true,
    handle_analytics: true,
    handle_locker: true,
    handle_registered_member: true,
    handle_pending_member: true,
    handle_create_member: true,
    handle_notice: true,
    handle_wod: true,
    handle_setting: true
  },
  instructorToken: null,
  instructorDefaultPage: '/dashboard'
};

const mutations = {
  ...makeSetters([
    'instructorRoles',
    'instructorAccessAuth',
    'instructorToken',
    'instructorDefaultPage'
  ])
};

const getters = {
  ...makeGetters([
    'instructorRoles',
    'instructorAccessAuth',
    'instructorToken',
    'instructorDefaultPage'
  ])
};

const actions = {
  async syncInstructorRoles({ commit }) {
    const { data: instructorRoles } = await fiflboxApi.v2.getInstructorRoles();
    commit('setInstructorRoles', instructorRoles);
  },
  async syncInstructorAccessAuthById({ commit }, accessAuthId) {
    const {
      data: instructorAccessAuth
    } = await fiflboxApi.v2.getInstructorAccessAuthById(accessAuthId);
    commit('setInstructorAccessAuth', instructorAccessAuth);
  },
  async syncInstructorAccessAuthByToken({ commit, state }) {
    if (state.instructorToken) {
      const {
        data: instructorAccessAuth
      } = await fiflboxApi.v2.getInstructorAccessAuthByToken({
        token: state.instructorToken
      });
      commit('setInstructorAccessAuth', instructorAccessAuth[0]);
    } else {
      return;
    }
  },
  syncInstructorDefaultPage({ commit, state }) {
    const defaultPage = defaultPageDecider(state.instructorAccessAuth);
    commit('setInstructorDefaultPage', defaultPage);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
